import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { siteNav, siteName } from "@/mocks/mangaData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="grid w-9 h-9 place-items-center rounded-md bg-primary-500 text-background-50 text-lg">
              <i className="ri-heart-3-fill"></i>
            </span>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">
              {siteName}
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {siteNav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-primary-700 bg-primary-100/70"
                      : "text-foreground-800 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/chapters"
              className="hidden md:inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-magic-line text-base leading-none"></i>
              最新分话
            </Link>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "收起菜单" : "展开菜单"}
              aria-expanded={open}
              className="lg:hidden grid w-10 h-10 place-items-center rounded-md text-foreground-900 hover:bg-background-100"
            >
              <i className={`text-xl leading-none ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav
          className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur"
          aria-label="移动端导航"
        >
          <div className="mx-auto max-w-7xl px-4 py-3 flex flex-col gap-1">
            {siteNav.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === "/"}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-[15px] font-medium ${
                    isActive ? "text-primary-700 bg-primary-100/70" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/chapters"
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-medium"
            >
              <i className="ri-magic-line text-base leading-none"></i>
              最新分话
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}